import { ArtworkImage } from './ArtworkImage';
import React from 'react';
import { PersonalStory } from '../api';
import { useMonsterTokenStyle } from '../utils/clientSettings';
import { DigitalItemCard } from './DigitalItemCard';
import { SimpleMarkdown } from './SimpleMarkdown';

type PersonalStoryProps = {
    card: PersonalStory;
    hideTooltip?: boolean;
}

type PersonalStoryTextProps = {
  text: string;
}
export const PersonalStoryText: React.FC<PersonalStoryTextProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  const result = text.replaceAll("Fail:", '<br /><b>Fail:</b>').replaceAll("Pass:", '<b>Pass:</b>');
  return (
    <div dangerouslySetInnerHTML={{ __html: result}} />
  );
}

export const PersonalStoryCard: React.FC<PersonalStoryProps> = ({ card, hideTooltip }) => {
    const artwork = useMonsterTokenStyle();
    const progress = card.progress;
    const isBase = !!card.failDescription;
    if (artwork === 'Digital') {
        // Existing stories use plain labels; leave labels already inside markdown alone.
        const rulesText = (card.description || '').replace(/(^|\n|\s)(Pass:|Fail:)(?!\*)/g, '$1**$2**');
        const outcomes = <>
            {card.rewardName && card.rewardDescription && <section className="digital-item-readable-rules" aria-label="Pass outcome">
                <h3>{card.rewardName}</h3>
                <SimpleMarkdown text={card.rewardDescription} keyPrefix={`${card.name}-reward`} />
            </section>}
            {card.failName && card.failDescription && <section className="digital-item-readable-rules" aria-label="Fail outcome">
                <h3>{card.failName}</h3>
                <SimpleMarkdown text={card.failDescription} keyPrefix={`${card.name}-fail`} />
            </section>}
        </>;
        return <div className="x digital-personal-story-wrapper">
            <DigitalItemCard card={{ kind: 'personalStory', item: card }}
                rules={<SimpleMarkdown text={rulesText} keyPrefix={`${card.name}-rules`} />}
                typeLabel="" fullArtwork=""
                outcomeStyle={isBase ? undefined : card.isReward ? 'reward' : 'fail'}
                badge={progress != null && <span className="digital-personal-progress" aria-label={`${progress} progress markers`}>Progress: {progress}</span>}
                readableContent={<>{progress != null && <p>Progress markers: {progress}</p>}{isBase && outcomes}</>} />
            {isBase && !hideTooltip && <div className="investigator-personal-stories digital-personal-outcomes">
                <div className="investigator-personal-stories-tooltip">
                    {card.rewardName && card.rewardDescription && <PersonalStoryCard hideTooltip card={{ name: card.rewardName, description: card.rewardDescription, isReward: true }} />}
                    {card.failName && card.failDescription && <PersonalStoryCard hideTooltip card={{ name: card.failName, description: card.failDescription, isReward: false }} />}
                </div>
            </div>}
        </div>;
    }
    return (
        <div className='x'>
            <div className={`card personal-story ${!!card.failDescription ? 'base' : card.isReward ? 'reward' : 'fail'}`}>
                <div className='personal-story-title'>{card.name}</div>
                <div className='personal-story-description'>
                    <PersonalStoryText text={card.description || ''} />
                </div>
                {!!progress && (<div className='clue personal-story-clue'>
                    <ArtworkImage loading="lazy" src="/Clue.jpg" alt="Clue" style={{borderRadius:'50%'}} />
                    <span>{progress}</span>
                </div>)}
            </div>
            <div className='investigator-personal-stories'>
                {isBase && !hideTooltip && (
                    <div className='investigator-personal-stories-tooltip'>
                        {!!card?.rewardDescription && !!card?.rewardName && (
                            <PersonalStoryCard card={{
                            name: card?.rewardName,
                            isReward: true,
                            description: card?.rewardDescription
                            }} />
                        ) }
                        {!!card?.failDescription && !!card?.failName && (
                            <PersonalStoryCard card={{
                            name: card?.failName,
                            isReward: false,
                            description: card?.failDescription
                            }} />
                        ) }
                    </div>
                )}
            </div>
        </div>
    )
}
